import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Button } from '../../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../../core/components/molecules/Typography';
import { Modal } from '../../../../../../core/components/templates/Modal';
import type { MouseEvent } from 'react';

interface IMoveContentConfirmationModal {
  isOpen: boolean;
  selectedDate: Date | null;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

const MoveContentConfirmationModal: React.FC<IMoveContentConfirmationModal> = ({
  isOpen,
  selectedDate,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  const handleClose = () => {
    if (isLoading) {
      return;
    }

    onClose();
  };

  const handleCloseClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    handleClose();
  };

  const selectedDateLabel = (() => {
    if (!selectedDate) {
      return '';
    }

    const label = format(selectedDate, 'EEEE: dd/MM', { locale: ptBR });
    return label.charAt(0).toUpperCase() + label.slice(1);
  })();

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size='md'
      title='Mover conteúdo'
      noPadding
    >
      <div className='flex flex-col'>
        <div className='px-4 py-5'>
          <Typography size='h6'>
            Esta disciplina será movida para a data selecionada.
          </Typography>
          <Typography weight='bold' size='h6' className='my-4'>
            {selectedDateLabel}
          </Typography>
          <Typography weight='bold' size='h6'>
            Deseja confirmar essa alteração?
          </Typography>
        </div>
        <div className='flex items-center justify-center gap-sm border-t-hairline border-t-mono-color-light p-4'>
          <Button
            variant='text'
            full
            disabled={isLoading}
            onClick={handleCloseClick}
          >
            Voltar
          </Button>
          <Button variant='contained' full loading={isLoading} onClick={onConfirm}>
            Sim
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MoveContentConfirmationModal;
